import React from 'react'
import { Modal, Button } from 'react-bootstrap';

function SubscribePopup(props) {
    const { subscribemessagedata, subscribestatusdata, setSubscribeMessage, onHide, ...res } = props;
    const handelModalClose = () => {
        onHide(false);
        setSubscribeMessage('');
    }
    return (
        <>
            <Modal
                {...res}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop='static'
                className={`subscribe-outer ${subscribestatusdata ? 'subscribe-warning' : 'subscribe-success'}`}

            >
                <Modal.Header className='border-0'>
                    <div className='d-flex w-100 justify-content-end'>
                        <Button variant="outline-secondary" onClick={handelModalClose}>X</Button>
                    </div>
                </Modal.Header>

                <Modal.Body>
                    {
                        !subscribemessagedata &&
                        <div className='d-flex justify-content-center align-items-center h-100'>
                            <div className="spinner-border" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    }

                    {subscribemessagedata && <>
                        <div className="checkIcon">
                            {
                                subscribestatusdata ?
                                    <i className="fa-solid fa-circle-exclamation"></i>
                                    :
                                    <i className="fa-solid fa-circle-check"></i>
                            }
                        </div>
                        <h4 className='subscribe-heading'>
                            {
                                subscribestatusdata ?
                                    'Your email address is already subscribed to Poppin Job!'
                                    :
                                    'Thank You!'
                            }
                            <i className="fa-solid fa-thumbs-up"></i>
                        </h4>
                        <p className='subscribe-text'>
                            {subscribemessagedata} <br />
                            <a href='mailto:support@poppinjob.com'>support@poppinjob.com</a>
                        </p>
                    </>}
                </Modal.Body>
            </Modal>
        </>
    );
}

export default SubscribePopup
